<script lang="ts">
	import BaseConditionNode from '../BaseConditionNode.svelte';
	import type { NodeData, NodeType } from '../../types/flow-types';
	import {
		resolveFlowConfiguredSummary,
		resolveFlowNodeTypeLabel,
	} from '../../helpers/flowNodeCardPresentation';

	export let id: string;
	export let data: NodeData;
	export let selected: boolean = false;
	export let validated: boolean = true;
	export let errors: string[] = [];

	$: isAlarm = data.filterType === 'alarm';
	$: nodeType = (isAlarm ? 'alarmCondition' : 'sceneCondition') as NodeType;
	$: displayText = resolveFlowConfiguredSummary(
		data,
		isAlarm ? 'Configure alarm condition' : 'Configure scene state',
	);
	$: nodeTypeLabel = resolveFlowNodeTypeLabel(nodeType, data);
</script>

<BaseConditionNode
	{id}
	type={nodeType}
	{data}
	{selected}
	{validated}
	{errors}
	cardTitle={displayText}
	{nodeTypeLabel}
	{...$$restProps}
/>
